import React, { useState, useEffect } from 'react';
import { Plus, Trash2, Save, X } from 'lucide-react';

function TranscriptEditor({ initialTranscript, onSave, onCancel }) {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    if (initialTranscript?.entries) {
      setEntries(initialTranscript.entries);
    } else {
      setEntries([{ speaker: 'Customer', text: '' }]);
    }
  }, [initialTranscript]);

  const addEntry = () => {
    setEntries([...entries, { speaker: 'Customer', text: '' }]);
  };

  const removeEntry = (index) => {
    setEntries(entries.filter((_, i) => i !== index));
  };

  const updateEntry = (index, field, value) => {
    const updated = [...entries];
    updated[index][field] = value;
    setEntries(updated);
  };

  const handleSave = () => {
    const transcript = {
      version: '1.0',
      entries: entries.filter(e => e.text.trim())
    };
    onSave(transcript);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h4 className="text-sm font-medium text-gray-900">Edit Transcript</h4>
        <div className="flex gap-2">
          <button
            onClick={onCancel}
            className="text-xs px-3 py-1 border rounded hover:bg-gray-50"
          >
            <X className="w-3 h-3 inline mr-1" />
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="text-xs px-3 py-1 bg-red-800 text-white rounded hover:bg-red-900"
          >
            <Save className="w-3 h-3 inline mr-1" />
            Save
          </button>
        </div>
      </div>

      <div className="space-y-2">
        {entries.map((entry, idx) => (
          <div key={idx} className="flex gap-2 items-start">
            <select
              value={entry.speaker}
              onChange={(e) => updateEntry(idx, 'speaker', e.target.value)}
              className="text-xs px-2 py-1 border rounded w-28"
            >
              <option>Customer</option>
              <option>Staff</option>
              <option>Team Member</option>
              <option>Manager</option>
            </select>

            <textarea
              value={entry.text}
              onChange={(e) => updateEntry(idx, 'text', e.target.value)}
              placeholder="Enter what was said..."
              rows={2}
              className="flex-1 text-xs px-2 py-1 border rounded focus:outline-none focus:ring-1 focus:ring-red-800"
            />

            <button
              onClick={() => removeEntry(idx)}
              className="text-red-600 hover:text-red-800 p-1"
              title="Remove entry"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>

      <button
        onClick={addEntry}
        className="text-xs text-gray-600 hover:text-gray-800 flex items-center"
      >
        <Plus className="w-3 h-3 mr-1" />
        Add Entry
      </button>
    </div>
  );
}

export default TranscriptEditor;
